import React from 'react'
import "./Define.css";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import { clearStatus } from "./defineSlice";

const alertFontSize = "15px";

function SharedComponent() {
    const dispatch = useDispatch();
    const define = useSelector((state) => state.define);
    const {
        isSuccess,
        isSuccess_Info,
        isFailed,
        isFailed_Info,
        isError,
        isError_Info,
    } = define;

    const handleCloseSnackbar = () => {
        dispatch(clearStatus());
    };
    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={isSuccess}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} variant="filled" severity="success" sx={{ width: "100%", fontSize: alertFontSize }}>
                    {isSuccess_Info}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={isFailed}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} variant="filled" severity="warning" sx={{ width: "100%", fontSize: alertFontSize }}>
                    {isFailed_Info}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={isError}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} variant="filled" severity="error" sx={{ width: "100%", fontSize: alertFontSize }}>
                     {isError_Info}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default SharedComponent
